import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { assert_equal, assert_number_gt_0, assert_string_not_empty, assert_true, assert_type_enum } from '@shared/asserts/utils_asserts';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__ml_asset_family } from '../sd/_enums/ENUM__ml_asset_family';
import { ENUM__ml_asset_type } from '../sd/_enums/ENUM__ml_asset_type';
import { DTO__ml_asset } from '../sd/ml_asset/DTO__ml_asset';

export class DTO__ml_asset_reservation extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.ML_ASSET_RESERVATION;

  /*
   * STATIC METHODS
   */

  static sort_by_expired_at_z_to_a(a: DTO__ml_asset_reservation, b: DTO__ml_asset_reservation) {
    return b.expired_at - a.expired_at;
  }

  static sort_by_expired_at_a_to_z(a: DTO__ml_asset_reservation, b: DTO__ml_asset_reservation) {
    return this.sort_by_expired_at_z_to_a(a, b);
  }

  /*
   * PROPERTIES
   */
  get is_free_for_rent() {
    return this.expired_at == CONSTANTS__shared.ML_ASSET_RESERVATION_FREE_TIMESTAMP_EXPIRED_AT;
  }

  /*
   * DB FIELDS
   */

  workspace_id!: string;
  user_id_creator!: string;

  family!: ENUM__ml_asset_family;

  ml_asset_hashes!: string[];

  expired_at!: number; //timestamp_ms
  /*
   * RUNTIME FIELDS
   */

  //key - hash
  ml_assets_map: MAP__serializable<string, DTO__ml_asset>;

  /*
   * METHODS
   */
  constructor() {
    super();
    this.ml_assets_map = new MAP__serializable();
  }

  /*
   * GETTERS
   */
  get_total_size_on_disk() {
    let out = 0;

    for (let value of this.ml_assets_map.values()) out += value.size_disk;

    return out;
  }

  get_size_disk_intersect_with(other: DTO__ml_asset_reservation) {
    let out = 0;

    for (let [key, value] of this.ml_assets_map.entries()) {
      if (!other.ml_assets_map.has(key)) continue;

      out += value.size_disk;
    }
  }

  get_ml_asset_hashes() {
    let out = Array.from(this.ml_assets_map.keys());

    return out;
  }

  /*
   * ASSERTS
   */

  assert_standard_fields() {
    super.assert_standard_fields();

    assert_string_not_empty(this.workspace_id);
    assert_string_not_empty(this.user_id_creator);

    assert_type_enum(this.family, ENUM__ml_asset_family);

    this.assert_model_assets();

    assert_number_gt_0(this.expired_at);
  }

  assert_model_assets() {
    return; //todo:remove

    assert_number_gt_0(this.ml_assets_map.size());

    this.assert_at_least_one_ml_asset_with_type(ENUM__ml_asset_type.UNET);
    this.assert_at_least_one_ml_asset_with_type(ENUM__ml_asset_type.VAE);
    this.assert_at_least_one_ml_asset_with_type(ENUM__ml_asset_type.TEXT_ENCODER);

    this.assert_family_types();
  }

  assert_at_least_one_ml_asset_with_type(type: ENUM__ml_asset_type) {
    let is_exists = false;

    for (let value of this.ml_assets_map.values()) {
      if (value.type != type) continue;

      is_exists = true;
      break;
    }

    assert_true(is_exists, { assert_type: ENUM__error_type.VALIDATION_ITEM_NOT_FOUND, type });
  }

  assert_family_types() {
    for (let value of this.ml_assets_map.values()) {
      assert_equal(this.family, value.family, { context: value.family });
    }
  }

  /*
   * ASSERTS SETTINGS
   */

  assert_settings(settings: 'DTO__generation_settings_sd_1') {}

  private assert_model_asset(hash_sha256: string, type: ENUM__ml_asset_type) {
    let model_asset = this.ml_assets_map.get_or_assert(hash_sha256);

    assert_equal(model_asset.type, type);
  }
}
